module.exports = __webpack_public_path__ + "img/slide3.08afb49b.png";